/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import { filterDomProps } from "common/vue/filter-dom-props";
import { useVueProps, vueDefaultValue } from "common/vue/useVueProps";
import "./Stars.react.scss";
import { renderList } from "common/vue/render-list";

// @ts-expect-error TS(6133): 'rawProps' is declared but its value is never read... Remove this comment to see the full error message
function getDefaultProps(rawProps: any) {
  return {
    stars: vueDefaultValue(0),
    size: vueDefaultValue("XS")
  };
}

export default function (rawProps: any) {
  const { className, stars, size, ...restProps } = rawProps;

  const props = useVueProps(rawProps, getDefaultProps);

  function display_stars() {
    const numericStarsNumber = Math.min(Math.max(parseFloat(props.current.stars), 0), 5);
    const fullStars = Math.floor(numericStarsNumber);
    const fractionalStar = Math.round((numericStarsNumber - fullStars) * 10);
    return [
      ...Array(fullStars).fill("100"),
      ...(fractionalStar ? [`${fractionalStar * 10}`] : []),
      ...Array(5 - fullStars - (fractionalStar ? 1 : 0)).fill("0")
    ];
  }

  return (
    // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
    <div className={cn("stars scope-778cdc16", className)} {...filterDomProps(restProps)}>
      {renderList(display_stars(), (star, index) => (
        <span
          className={cn("stars__item scope-778cdc16", [
            `stars__item--fill-${star}`,
            `stars__item--${props.current.size}`
          ])}
          key={index}
        />
      ))}
    </div>
  );
}
